import { Box } from '@mui/material';

import { ShareWithAFriendForm } from '@/containers';

export const ShareWithAFriend = () => {
  return (
    <Box sx={{ maxWidth: 700, mx: 'auto' }}>
      <ShareWithAFriendForm showSuccessView={true} />
    </Box>
  );
};
